export const AUTH_REFRESH_MODE = "cookie"; // "legacy", "cookie"
